export default __webpack_public_path__ + "static/media/img1.3d4d3395.jpg";